import type React from 'react'
import { cn } from '@/lib/styles'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-sm bg-primary/10', className)} {...props} />
}

export { Skeleton }
